export function formatNumberWithCommas(number = 0) {
  return new Intl.NumberFormat().format(number);
}
